<template>
    <div v-if="providerList"
         id="compare-div"
         class="d-flex flex-column flex-xl-row align-items-end p-0 w-100">
        <div class="d-flex flex-column w-100 mb-1 mb-xl-0">
            <label class="mb-1">
                <strong>{{
                    vertical === 'edu'
                        ? getTrans('learning-platform-compare.choice1', '1st Learning Platform')
                        : categoryType === 'exchange'
                            ? getTrans('exchange-compare.choice1', '1st Crypto Exchange')
                            : categoryType === 'cryptocurrency'
                                ? getTrans('cryptocurrency-compare.choice1', 'Placeholder1')
                                : getTrans('wallet-compare.choice1', '1st Crypto Wallet')
                }}</strong>
            </label>
            <provider-dropdown :options="comparingProviderOptions"
                               :placeholder="getTrans('exchange-compare.comparePlaceholder')"
                               class="mr-0 mr-md-3"
                               @selectProvider="(value) => saveSelectionAndReset(value, 1)" />
            <input :value="comparingProvider"
                   name="comparingProvider"
                   type="hidden">
        </div>
        <div class="d-flex flex-column w-100 mt-2 mt-xl-0 mb-1 mb-xl-0">
            <label class="mb-1">
                <strong>{{
                    vertical === 'edu'
                        ? getTrans('learning-platform-compare.choice2', '2nd Learning Platform')
                        : categoryType === 'exchange'
                            ? getTrans('exchange-compare.choice2', '2nd Crypto Exchange')
                            : categoryType === 'cryptocurrency'
                                ? getTrans('cryptocurrency-compare.choice2', 'Placeholder2')
                                : getTrans('wallet-compare.choice2', '2nd Crypto Wallet')
                }}</strong>
            </label>
            <provider-dropdown :options="comparedProviderOptions"
                               :placeholder="getTrans('exchange-compare.comparePlaceholder')"
                               class="mr-0 mr-md-3"
                               @selectProvider="(value) => saveSelectionAndReset(value, 2)" />
            <input :value="comparedProvider"
                   name="comparedProvider"
                   type="hidden">
        </div>
        <div class="compare-button-block d-flex flex-column align-items-center mt-sm-3 mt-xl-0">
            <button class="button button__big button--red mx-auto mx-lg-0 mt-3"
                    type="submit"
                    :disabled="isButtonDisabled"
                    @click="handleButtonClick">
                {{ getTrans('exchange-compare.compareNow') }}
            </button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import ProviderDropdown from '@/js/comparisons/ProviderDropdown.vue';
    import { getTrans } from '@/js/helpers/getTrans';

    export default {
        name: 'ProviderPicker',
        components: { ProviderDropdown },
        props: {
            providers: {
                type: [Array],
                required: true,
            },
            vertical: {
                type: String,
                required: true,
            },
            categoryType: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                comparingProvider: null,
                comparedProvider: null,
                providerList: null,
            };
        },
        computed: {
            isButtonDisabled() {
                if (this.comparingProvider && this.comparedProvider) {
                    this.enableButton();

                    return false;
                }

                return true;
            },
            comparingProviderOptions() {
                if (!this.comparedProvider) {
                    return this.providers;
                }

                return this.providers.filter((p) => p.slug !== this.comparedProvider.slug);
            },
            comparedProviderOptions() {
                if (!this.comparingProvider) {
                    return this.providers;
                }

                return this.providers.filter((p) => p.slug !== this.comparingProvider.slug);
            },
        },
        mounted() {
            this.disableButton();
        },
        created() {
            this.providerList = this.providers;
        },
        methods: {
            getTrans,
            enableButton() {
                const formButton = document.querySelector('.button__big');
                formButton.style.opacity = '1';
                formButton.style.pointerEvents = 'all';
            },
            disableButton() {
                const formButton = document.querySelector('.button__big');
                formButton.style.opacity = '0.8';
                formButton.style.pointerEvents = 'none';
            },
            saveSelectionAndReset(option, index) {
                if (index === 1) {
                    this.comparingProvider = option;
                } else {
                    this.comparedProvider = option;
                }
            },
            async handleButtonClick() {
                const url = '/api/compare-pages/url';

                const response = await axios.post(url, {
                    vertical: this.vertical,
                    category_type: this.categoryType,
                    slug1: this.comparingProvider.slug,
                    slug2: this.comparedProvider.slug,
                });

                if (response.data.data.url) {
                    window.location.href = response.data.data.url;
                }
            },
        },
    };
</script>

<style scoped lang="scss">
@use "@/sass/partials/breakpoints" as breakpoints;

.compare-button-block {
    width: 100%;

    @media (min-width: breakpoints.$xl-breakpoint) {
        width: unset;
    }

    .button {
        padding: 8px 20px;

        @media (min-width: breakpoints.$xl-breakpoint) {
            width: unset;
            min-height: 40px;
        }
    }
}
</style>
